module.exports = __webpack_public_path__ + "img/dwonload.4139e169.png";